import React, { useEffect, useRef, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Loading } from '@ktag/styleguide/dist/react';
import AppContext from 'AppContext';
import { MailingContent } from 'types/api.types';

const Viewer = () => {
  const webComponentRef = useRef(null);
  const { newsletterApi } = useContext(AppContext);
  const { mailingId } = useParams<{ mailingId: string }>();

  const { data, isLoading } = useQuery<MailingContent>(
    ['mailingContent', Number(mailingId)],
    () => newsletterApi.getMailingContent(Number(mailingId)),
  );

  // This function removes the "Online ansehen" link from the HTML string
  const removeOnlineAnsehen = (htmlString: string): string => {
    // filters both <a>...Online Ansehen...</a> and <a>...<span>Online ansehen<span/>...<a/>
    const regex =
      /<a[^>]*?>\s*(<span[^>]*?>\s*Online ansehen\s*<\/span>|Online ansehen)\s*<\/a>/g;
    const matches = htmlString.match(regex) || [];
    // Only removes if there is a single match to avoid damaging further content
    return matches.length === 1 ? htmlString.replace(regex, '') : htmlString;
  };

  useEffect(() => {
    if (!isLoading && data?.html) {
      const htmlContentTransformed = removeOnlineAnsehen(
        data.html.replace(/\\"/g, '"').replace(/\\n/g, ''),
      );

      const webComponent = document.createElement('newsletter-container');
      const shadowRoot = webComponent.attachShadow({ mode: 'open' });

      const container = document.createElement('div');
      container.innerHTML = htmlContentTransformed;
      shadowRoot.appendChild(container);

      webComponentRef.current.appendChild(webComponent);

      return () => {
        webComponentRef.current.removeChild(webComponent);
      };
    }
    return undefined;
  }, [data, isLoading]);

  if (isLoading) {
    return <Loading size="medium" />;
  }

  return <div ref={webComponentRef} />;
};

export default Viewer;
